(() => {
  if (window.spotecForgeLoaded) return;
  window.spotecForgeLoaded = true;
  // Persist independently for intro and popup. Editor previews never consume a visit.
  const visitMemory = new Set();
  window.spotecVisitGate = {
    key(id, version) { return 'spotec:visit:' + id + ':' + (version || '1'); },
    seen(id, frequency, version) {
      if (frequency === 'always') return false;
      const key = this.key(id, version), cookie = encodeURIComponent(key) + '=1';
      try { if (window[frequency === 'once' ? 'localStorage' : 'sessionStorage'].getItem(key)) return true; } catch (_) {}
      return visitMemory.has(key) || document.cookie.split('; ').includes(cookie);
    },
    mark(id, frequency, version) {
      if (frequency === 'always') return;
      const key = this.key(id, version);
      visitMemory.add(key);
      try { window[frequency === 'once' ? 'localStorage' : 'sessionStorage'].setItem(key, '1'); return; } catch (_) {}
      // Session cookie fallback only when browser storage is unavailable.
      try { document.cookie = encodeURIComponent(key) + '=1; Path=/; SameSite=Lax' + (frequency === 'once' ? '; Max-Age=31536000' : ''); } catch (_) {}
    }
  };
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const updateHeader = () => document.querySelectorAll('[data-sf-header]').forEach(h => h.classList.toggle('is-scrolled', scrollY > 24));
  const updateCategories = section => {
    const track = section.querySelector('.sf-category-track'); if (!track) return;
    const prev = section.querySelector('[data-sf-category-prev]'); const next = section.querySelector('[data-sf-category-next]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  const initialize = () => {
    updateHeader();
    document.querySelectorAll('.sf-categories').forEach(section => {
      updateCategories(section);
      const track = section.querySelector('.sf-category-track');
      if (track && !track.dataset.sfBound) {
        track.dataset.sfBound = 'true'; track.addEventListener('scroll', () => updateCategories(section), {passive:true});
      }
    });
  };
  window.addEventListener('scroll', updateHeader, {passive:true});
  window.addEventListener('resize', initialize, {passive:true});
  document.addEventListener('shopify:section:load', initialize);
  initialize();
  document.addEventListener('click', event => {
    const thumb = event.target.closest('[data-sf-photo]');
    if (thumb) {
      const card = thumb.closest('[data-sf-product]'); const image = card?.querySelector('.sf-product__image');
      if (image?.tagName === 'IMG') {
        image.removeAttribute('srcset'); image.src = thumb.dataset.sfPhoto; image.alt = thumb.dataset.sfAlt || '';
        card.querySelectorAll('[data-sf-photo]').forEach(b => {b.setAttribute('aria-pressed', String(b === thumb)); if(b===thumb)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});
      }
    }
    const categoryButton = event.target.closest('[data-sf-category-prev],[data-sf-category-next]');
    if (categoryButton) {
      const section = categoryButton.closest('.sf-categories'); const track = section.querySelector('.sf-category-track');
      const step = (track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + (parseFloat(getComputedStyle(track).gap) || 0);
      track.scrollBy({left:step * (categoryButton.hasAttribute('data-sf-category-prev') ? -1 : 1),behavior:motion.matches?'instant':'smooth'});
    }
    const pause = event.target.closest('[data-sf-marquee-pause]');
    if (pause) {const parent = pause.closest('[data-sf-marquee]'); const paused = parent.classList.toggle('is-paused'); pause.setAttribute('aria-pressed',String(paused)); pause.setAttribute('aria-label',paused?'Play running text':'Pause running text'); pause.textContent=paused?'▶':'Ⅱ';}
    document.querySelectorAll('.sf-dropdown[open],.sf-mobile-menu[open]').forEach(d => {if(!d.contains(event.target)) d.removeAttribute('open');});
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.sf-dropdown[open],.sf-mobile-menu[open]').forEach(d => {d.removeAttribute('open'); d.querySelector('summary')?.focus();});
  });
// The timeout and SVG ring share one elapsed clock; interruptions preserve remaining time.
if (!window.SpotecSlideClock) window.SpotecSlideClock = class {
  constructor(host, advance) { this.host=host; this.advance=advance; this.started=null; this.duration=0; this.remaining=0; }
  reset(duration) {
    this.stop(); this.animation?.cancel(); this.animation=null;
    this.duration=duration; this.remaining=duration;
    this.ring=this.host.querySelector('[data-slide-progress]');
    if(this.ring) this.ring.style.strokeDashoffset='100';
  }
  stop() {
    clearTimeout(this.timer);
    if(this.started!==null) this.remaining=Math.max(0,this.remaining-(performance.now()-this.started));
    this.started=null;
    if(this.animation){this.animation.pause();this.animation.currentTime=this.duration-this.remaining;}
  }
  sync(duration, run) {
    if(this.duration!==duration) this.reset(duration);
    if(!run){this.stop();return;}
    if(this.started!==null)return;
    if(!this.animation && this.ring?.animate) {
      this.animation=this.ring.animate([{strokeDashoffset:'100'},{strokeDashoffset:'0'}],{duration:this.duration,fill:'forwards',easing:'linear'});
    }
    if(this.animation){this.animation.currentTime=this.duration-this.remaining;this.animation.play();}
    this.started=performance.now();
    this.timer=setTimeout(()=>{
      this.started=null;this.remaining=0;
      this.animation?.finish();
      if(this.ring)this.ring.style.strokeDashoffset='0';
      this.advance();
    },this.remaining);
  }
  destroy(){this.stop();this.animation?.cancel();this.animation=null;}
};
  class SfHeroSlider extends HTMLElement {
    connectedCallback() {
      if(this.controller) return;
      this.controller = new AbortController(); const opts={signal:this.controller.signal};
      this.slides=[...this.querySelectorAll('[data-sf-slide]')];this.dots=[...this.querySelectorAll('[data-sf-dot]')];this.index=0;this.paused=motion.matches;this.hovered=false;this.focused=false;this.visible=true;this.editorSelected=false;
      this.querySelector('[data-sf-prev]')?.addEventListener('click',()=>this.show(this.index-1,true),opts);
      this.querySelector('[data-sf-next]')?.addEventListener('click',()=>this.show(this.index+1,true),opts);
      this.dots.forEach((d,i)=>d.addEventListener('click',()=>this.show(i,true),opts));
      this.querySelector('[data-sf-pause]')?.addEventListener('click',()=>{
        this.paused=!this.paused;const b=this.querySelector('[data-sf-pause]');if(!this.paused)this.focused=false;b.setAttribute('aria-pressed',String(this.paused));b.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');this.schedule();
      },opts);
      this.addEventListener('mouseenter',()=>{this.hovered=this.dataset.pauseOnHover==='true';this.schedule();},opts);
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},opts);
      this.addEventListener('focusin',event=>{this.focused=event.target.matches?.(':focus-visible')??true;this.schedule();},opts);
      this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.schedule();}},opts);
      this.addEventListener('keydown',event=>{if(/INPUT|TEXTAREA|SELECT|VIDEO/.test(event.target.tagName))return;if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1),true);}},opts);
      this.addEventListener('pointerdown',event=>{if(event.pointerType==='touch'&&!event.target.closest('video,button,a:not(.sf-slide__hit)'))this.touchStart={x:event.clientX,y:event.clientY};},opts);
      this.addEventListener('pointerup',event=>{if(!this.touchStart)return;const dx=event.clientX-this.touchStart.x,dy=event.clientY-this.touchStart.y;this.touchStart=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)this.show(this.index+(dx<0?1:-1),true);},opts);
      this.addEventListener('pointercancel',()=>{this.touchStart=null;},opts);
      document.addEventListener('visibilitychange',()=>{this.syncVideo();this.schedule();},opts);
      motion.addEventListener('change',()=>{this.syncVideo();this.schedule();},opts);
      this.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('[data-sf-slide]');const i=this.slides.indexOf(slide);if(i>=0){this.editorSelected=true;this.show(i,true);}},opts);
      this.addEventListener('shopify:block:deselect',()=>{this.editorSelected=false;this.schedule();},opts);
      this.observer = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.syncVideo();this.schedule();},{threshold:0.1});this.observer.observe(this);
      this.slides.forEach(slide=>slide.querySelectorAll('video').forEach(v=>{
        v.addEventListener('play',()=>this.schedule(),opts);v.addEventListener('pause',()=>this.schedule(),opts);
      }));
      document.addEventListener('spotec:popup-toggle',()=>{this.syncVideo();this.schedule();},opts);
      const pause=this.querySelector('[data-sf-pause]');if(pause){pause.setAttribute('aria-pressed',String(this.paused));pause.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');}
      this.clock=new window.SpotecSlideClock(this,()=>{this.introFirstDelay=false;this.show(this.index+1);});
      this.setupIntro(opts);
      this.show(0);
    }
    setupIntro(opts){
      const editor=Boolean(window.Shopify?.designMode);
      const frequency=this.dataset.introFrequency||'session';
      const key='intro-'+(this.dataset.sectionId||'hero');
      this.introPending=this.dataset.intro==='true' && !motion.matches && scrollY<80
        && (!editor || this.dataset.introPreview==='true')
        && (editor || !window.spotecVisitGate.seen(key,frequency,this.dataset.introVersion));
      this.classList.toggle('sf-intro-pending',this.introPending);
      // The early inline script may already have blurred the header; undo it when the intro is skipped.
      if(!this.introPending){document.documentElement.classList.remove('sf-page-intro-active');document.documentElement.style.removeProperty('--sf-header-blur');return;}
      if(!editor)window.spotecVisitGate.mark(key,frequency,this.dataset.introVersion);
      const root=document.documentElement;
      let progress=0,touchY=null;
      const paint=()=>{this.style.setProperty('--sf-intro-progress',String(progress));root.style.setProperty('--sf-header-blur',`${(Number(this.dataset.introBlur)||0)*(1-progress)}px`);};
      root.classList.add('sf-page-intro-active');paint();
      this.clearIntro=()=>{root.classList.remove('sf-page-intro-active');root.style.removeProperty('--sf-header-blur');};
      const reveal=()=>{
        if(!this.introPending)return;
        clearTimeout(this.introAutoTimer);progress=1;paint();this.introPending=false;
        this.classList.toggle('sf-intro-pending',false);this.classList.toggle('sf-intro-revealing',true);
        this.introTimer=setTimeout(()=>{
          this.classList.toggle('sf-intro-revealing',false);this.clearIntro();
          const button=this.querySelector('[data-sf-reveal]');
          if(document.activeElement===button){button.blur();this.focused=false;}
          this.introFirstDelay=true;this.schedule();document.dispatchEvent(new CustomEvent('spotec:intro-complete'));
          // Stop holding every wheel/touch gesture once the intro is over (keeps scrolling smooth).
          window.removeEventListener('wheel',onWheel);window.removeEventListener('touchmove',onTouchMove);
        },650);
      };
      if(this.dataset.introMode!=='gesture')this.introAutoTimer=setTimeout(reveal,Math.max(1000,Number(this.dataset.introDuration)||2000));
      window.addEventListener('pagehide',()=>{clearTimeout(this.introAutoTimer);clearTimeout(this.introTimer);this.introPending=false;this.classList.remove('sf-intro-pending','sf-intro-revealing');this.clearIntro();window.removeEventListener('wheel',onWheel);window.removeEventListener('touchmove',onTouchMove);},opts);
      // One downward gesture reveals the intro while its transition holds the page in place.
      const onWheel=event=>{
        if(event.ctrlKey||(!this.introPending&&!this.classList.contains('sf-intro-revealing')))return;
        if(!event.cancelable)return;
        event.preventDefault();
        if(!this.introPending)return;
        if(event.deltaY>0)reveal();
      };
      window.addEventListener('wheel',onWheel,{...opts,passive:false});
      window.addEventListener('touchstart',event=>{if(event.touches.length===1){touchY=event.touches[0].clientY;}},{...opts,passive:true});
      const onTouchMove=event=>{
        if(event.touches.length!==1||touchY===null||(!this.introPending&&!this.classList.contains('sf-intro-revealing')))return;
        if(!event.cancelable)return;event.preventDefault();
        const delta=touchY-event.touches[0].clientY;
        if(this.introPending&&delta>8)reveal();
      };
      window.addEventListener('touchmove',onTouchMove,{...opts,passive:false});
      window.addEventListener('keydown',event=>{
        if(!this.introPending||/INPUT|TEXTAREA|SELECT/.test(event.target.tagName))return;
        if(['Escape','Tab','End'].includes(event.key)){reveal();return;}
        if(['ArrowDown','PageDown',' '].includes(event.key)){event.preventDefault();reveal();}
      },opts);
      // Scrollbar dragging, restored positions and editor navigation must not trap the page.
      window.addEventListener('scroll',()=>{if(scrollY>80)reveal();},{...opts,passive:true});
      this.querySelector('[data-sf-reveal]')?.addEventListener('click',reveal,opts);
      this.addEventListener('shopify:block:select',reveal,opts);
      motion.addEventListener('change',()=>{if(motion.matches)reveal();},opts);
    }
    disconnectedCallback(){this.clock?.destroy();this.clearIntro?.();clearTimeout(this.introTimer);clearTimeout(this.introAutoTimer);clearTimeout(this.timer);this.observer?.disconnect();this.controller?.abort();this.controller=null;this.slides?.forEach(s=>s.querySelectorAll('video').forEach(v=>v.pause()));}
    show(index,announce=false){
      if(!this.slides.length)return;
      if(announce)this.introFirstDelay=false;
      this.clock?.reset(this.slideDuration());
      this.index=(index+this.slides.length)%this.slides.length;
      this.classList.toggle('has-video',Boolean(this.slides[this.index].querySelector('video')));
      this.slides.forEach((slide,i)=>{const active=i===this.index;slide.hidden=!active;slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));slide.classList.toggle('is-active',active);if(!active)slide.querySelectorAll('video').forEach(v=>v.pause());});
      this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));
      if(announce){const status=this.querySelector('[data-sf-slide-status]');if(status)status.textContent=`Slide ${this.index+1} of ${this.slides.length}`;}
      this.syncVideo();this.schedule();
    }
    syncVideo(){
      this.slides.forEach((slide,i)=>slide.querySelectorAll('video').forEach(v=>{
        if(i!==this.index||document.hidden||!this.visible||document.querySelector('dialog[open]')){v.pause();return;}
        // Videos remain user-controlled. Native play/pause, seeking and sound controls stay available.
      }));
    }
    slideDuration(){return this.introFirstDelay?Math.max(3000,Number(this.dataset.introDelay)||4000):Math.max(3000,Number(this.dataset.interval)||5000);}
    schedule(){
      const playing=this.slides[this.index]?.querySelector('video');
      const blocked=document.querySelector('dialog[open]')||this.introPending||this.classList.contains('sf-intro-revealing')||this.dataset.autoplay!=='true'||this.slides.length<2||this.paused||this.hovered||this.focused||this.editorSelected||!this.visible||document.hidden||motion.matches||(playing&&!playing.paused);
      this.clock?.sync(this.slideDuration(),!blocked);
    }
  }
  if(!customElements.get('sf-hero-slider'))customElements.define('sf-hero-slider',SfHeroSlider);
})();
